"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryNav = void 0;
const organism_1 = require("./organism");
const props_1 = require("../common/props");
/**
 * The primary nav organism.
 * @category Organisms
 */
class PrimaryNav extends organism_1.Organism {
    constructor(organisms) {
        super("Primary Nav", organisms);
        this.fixed = new props_1.PropertyBoolean("Fixed", false, this);
        this.verticalPadding = new props_1.PropertyNumberSelectable("Vertical Padding", false, this, [0.5, 1, 2, 3], 1);
        this.horizontalTabPadding = new props_1.PropertyNumberSelectable("Horizontal Tab Padding", false, this, [0.5, 1, 2, 3], 1);
        this.navText = new props_1.PropertyButtonText("Nav Text", false, this);
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.fixed.deserialize(obj.fixed);
        this.verticalPadding.deserialize(obj.verticalPadding);
        this.horizontalTabPadding.deserialize(obj.horizontalTabPadding);
        this.navText.deserialize(obj.navText);
    }
    serialize() {
        const obj = {};
        obj.fixed = this.fixed.serialize();
        obj.verticalPadding = this.verticalPadding.serialize();
        obj.horizontalTabPadding = this.horizontalTabPadding.serialize();
        obj.navText = this.navText.serialize();
        return obj;
    }
}
exports.PrimaryNav = PrimaryNav;
